/* ============================================================
   KUOTA PAKEJ (WEBAPP) — kuota browser/avatar = default pakej + slot tambahan
   ============================================================
   Polisi user 2026-09-15 (muktamad):
     kuota = kuota DEFAULT pakej yang dibayar + SLOT TAMBAHAN
     Default: Premium 3 · SMART 3 · Fighter 6.
     Slot tambahan = add-on FLOWNITY (+1) atau slot yang admin bagi.
     First batch (RM499, default 5) BUKAN slot tambahan.

   Dipakai oleh AdminView: popup Aktifkan (cadangan kuota bila pakej dipilih)
   dan Edit Client (medan "Slot Tambahan").

   ⚠️⚠️ FAIL KEMBAR — salinan kedua di SERVER: functions/kuotaPakej.js
      (bayaran Billplz + adminApprovePayment). Ubah default / had / peraturan
      di satu tempat = ubah di kedua-dua, kalau tidak popup admin mencadangkan
      nombor yang berbeza daripada yang bayaran Billplz tulis.

   Medan: licenses/{uid}.slotTambahan (integer 0..HAD_SLOT_TAMBAHAN).
   TIADA medan = belum direkod → sandaran perangai lama (ambil nombor tertinggi).
   ============================================================ */

export const KUOTA_DEFAULT = Object.freeze({ monthly: 3, smart: 3, yearly: 6 });
export const HAD_SLOT_TAMBAHAN = 50;
export const HAD_KUOTA = 60;

/** Slot tambahan yang direkod pada doc lesen. null = belum direkod / nilai rosak. */
export function bacaSlotTambahan(lesen) {
    const v = lesen ? lesen.slotTambahan : undefined;
    return Number.isInteger(v) && v >= 0 && v <= HAD_SLOT_TAMBAHAN ? v : null;
}

/** true bila medan WUJUD tetapi nilainya rosak. */
export function slotTambahanRosak(lesen) {
    return !!lesen && lesen.slotTambahan !== undefined && lesen.slotTambahan !== null
        && bacaSlotTambahan(lesen) === null;
}

/**
 * Kuota selepas pelanggan membayar satu pakej.
 * @param {number} kuotaDefault  default pakej yang dibayar (Premium 3 · Fighter 6)
 * @param {object|null} lesenSedia  data lesen sedia ada (null = pelanggan baharu)
 * @returns {{ maxProfiles: number, slotTambahan: number|null, cara: 'baharu'|'rekod'|'sandaran' }}
 */
export function kuotaSelepasBayar(kuotaDefault, lesenSedia) {
    if (!Number.isInteger(kuotaDefault) || kuotaDefault < 1) {
        throw new Error(`Kuota default pakej tidak sah: ${kuotaDefault}`);
    }
    if (!lesenSedia) return { maxProfiles: kuotaDefault, slotTambahan: 0, cara: 'baharu' };
    const tambahan = bacaSlotTambahan(lesenSedia);
    if (tambahan !== null) {
        return { maxProfiles: kuotaDefault + tambahan, slotTambahan: tambahan, cara: 'rekod' };
    }
    const lama = Number.isInteger(lesenSedia.maxProfiles) ? lesenSedia.maxProfiles : 0;
    return { maxProfiles: Math.max(lama, kuotaDefault), slotTambahan: null, cara: 'sandaran' };
}

/** Teks pecahan untuk popup admin, cth "6 default + 1 slot tambahan". '' bila tiada apa untuk dipecah. */
export function teksPecahanKuota(kuotaDefault, hasil) {
    if (!hasil) return '';
    if (hasil.cara === 'sandaran') return 'slot tambahan belum direkod — ikut nombor tertinggi';
    if (hasil.slotTambahan > 0) return `${kuotaDefault} default + ${hasil.slotTambahan} slot tambahan`;
    return '';
}
